(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mobile-nav"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const toggle = document.querySelector('.mobile-nav__toggle');
    const close = document.querySelector('.mobile-nav__close');
    const drawer = document.querySelector('.mobile-nav__drawer');
    const body = document.body;

    function openMenu() {
      drawer.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      body.style.overflow = 'hidden';
    }

    function closeMenu() {
      drawer.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      body.style.overflow = '';
    }

    toggle.addEventListener('click', openMenu);
    close.addEventListener('click', closeMenu);

    // Close menu when clicking outside
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer) {
        closeMenu();
      }
    });

    // Close menu on escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeMenu();
      }
    });

    // Close mobile menu when cart drawer opens
    document.addEventListener('drawerOpen', function (e) {
      if (e.detail.drawer === 'cart-drawer') {
        closeMenu();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-main"] && !window.DesignMode) return;
  try {
    
  (function () {
    // Debug flag
    const DEBUG = true;
    function log(...args) {
      if (DEBUG) console.log(...args);
    }

    function selectImage(thumbnail, imageUrl) {
      log('selectImage called', { thumbnail, imageUrl });

      // Update active state
      document.querySelectorAll('.thumbnail').forEach((thumb) => thumb.classList.remove('active'));
      thumbnail.classList.add('active');

      // Update main image
      const mainImage = document.getElementById('main-product-image');
      if (!mainImage) {
        console.error('Main image element not found!');
        return;
      }
      log('Current main image src:', mainImage.src);
      log('New image URL:', imageUrl);

      // Force image reload by adding timestamp
      const timestamp = new Date().getTime();
      const newUrl = imageUrl.includes('?') ? `${imageUrl}&t=${timestamp}` : `${imageUrl}?t=${timestamp}`;

      mainImage.src = newUrl;

      // Verify the change
      log('Updated main image src:', mainImage.src);
    }

    function initializeProductGallery() {
      log('Initializing product gallery');
      const thumbnails = document.querySelectorAll('.thumbnail');
      log('Found thumbnails:', thumbnails.length);

      thumbnails.forEach((thumbnail) => {
        thumbnail.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();

          const imageUrl = thumbnail.getAttribute('data-image-url');
          log('Thumbnail clicked', {
            imageUrl,
            thumbnailIndex: thumbnail.getAttribute('data-index'),
          });

          if (!imageUrl) {
            console.error('No image URL found on thumbnail');
            return;
          }

          selectImage(thumbnail, imageUrl);
        });
      });
    }

    // Initialize as soon as possible
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeProductGallery);
    } else {
      initializeProductGallery();
    }
  })();

  // Keep cart functionality separate
  // ... rest of cart code ...

  } catch(e) { console.error(e); }
})();
})();
